// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_-06","input":"styles_input__2w5jw"};